import React, { useState, useEffect } from "react";
import { Activity } from "lucide-react";

const WorkoutTimer = ({ startTime, isRunning }) => {
  const [elapsed, setElapsed] = useState(0);
  const timerActive = isRunning && startTime;

  useEffect(() => {
    if (!timerActive) return;

    const interval = setInterval(() => {
      setElapsed(Math.floor((Date.now() - startTime) / 1000));
    }, 1000);

    return () => clearInterval(interval);
  }, [timerActive, startTime]);

  const formatTime = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    
    if (hours > 0) {
      return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  return (
    <div className="bg-gradient-to-r from-primary/20 to-success/20 border border-primary/30 rounded-xl p-3 sm:p-4 mb-4 sm:mb-6" data-testid="workout-timer">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 sm:gap-3">
          <div className="w-8 h-8 sm:w-10 sm:h-10 bg-primary/30 rounded-full flex items-center justify-center flex-shrink-0">
            <Activity className="w-4 h-4 sm:w-5 sm:h-5 text-primary animate-pulse" />
          </div>
          <div>
            <p className="text-[10px] sm:text-xs text-text-secondary uppercase tracking-wide">Elapsed Time</p>
            <p className="font-heading text-2xl sm:text-3xl font-bold text-white tabular-nums" data-testid="timer-display">
              {timerActive ? formatTime(elapsed) : "0:00"}
            </p>
          </div>
        </div>
        <div className="text-right flex-shrink-0">
          <div className="flex items-center gap-1.5 sm:gap-2 text-success">
            <span className="w-2 h-2 bg-success rounded-full animate-pulse"></span>
            <span className="text-xs sm:text-sm font-medium">Active</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export { WorkoutTimer };
